import { OrderDetail } from './order';
export const trackUps = (...codes: string[]) => `https://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=${codes.join(',')}`;
export const trackUsps = (...codes: string[]) => `https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=${codes.join(',')}`;
export const trackDhl = (...codes: string[]) => `https://www.dhl.com/en/express/tracking.html?AWB=${codes.join(',')}&brand=DHL`;

export const trackPackages = (order: OrderDetail) => {
    const results = order.shipments.map(x => {
        switch (x.shippingMethod) {
            case 'UPS':
                return trackUps(x.trackingNumber);
            case 'USPS':
                return (x.trackingNumber.indexOf(' ') < 0) ? trackUsps(x.trackingNumber) : null;
            case 'DHL':
                return trackDhl(x.trackingNumber);
            default:
                return null;
        }
    }).filter(x => !!x);

    switch (results.length) {
        case 0:
            return null;
        case 1:
            return results[0];
        default:
            return results;
    }
};

export const getTrackingUrl = (order: OrderDetail) => {
    const results = trackPackages(order);

    return Array.isArray(results) ? results[0] : results;
};
